import React from 'react'
import { icons } from '../assets'
import { getMediaUrl } from '../helpers'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'

const AppInfoIcon = () => {
	const { theme } = useDefaultComponentTools()
	const url = getMediaUrl()
	return (
		<img src={theme.palette.mode === 'dark' ? url + icons.infoDark : url + icons.info} alt='info-icon'/>
	)
}

export default AppInfoIcon
